var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.mobile) ? 'stats-mobile-item' : 'stats-item'},[_c('font-awesome-icon',{class:_vm.type + '-icon',attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.count))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }